import { put, call } from 'redux-saga/effects'
import { getJobPreferences, patchJobPreferences } from '../apiModules/jobPreferences'
import { jobPreferenceEntities } from '../reducks'

export function* fetchJobPreferenceEntitySaga(params) {
  const response = yield call(getJobPreferences, params)
  yield put(jobPreferenceEntities.addItem(response.result.id, response.result))
  return response
}

export function* updateJobPreferenceEntitySaga(id, data) {
  const response = yield call(patchJobPreferences, id, data)
  yield put(jobPreferenceEntities.updateItem(response.result.id, response.result))
  return response
}
